import React from 'react';
import Button from "components/button";
import UseContext from "hooks/useContext";
import LoadingButton from "../../components/button/loading";

// Button labels follow the new mission flow: template selection (0),
// motif (3), schedule (5), invitation (7), confirmation (10).
const FooterButton = ({oC1, oC2, isLoading, disabled, templateSelectionMode}) => {
    const {page} = UseContext()

    if (templateSelectionMode) {
        return (
            <Button
                size={'LG'}
                onClick={oC1}
                disabled={disabled}
                color={disabled ? 'DISABLED' : 'PRIMARY'}
            >
                Créer une mission à partir du modèle
            </Button>
        );
    }

    const elements = {
        3: <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        5: <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        7: <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        10: isLoading
            ? <LoadingButton size={"LG"}>Création de la mission</LoadingButton>
            : <Button size={'LG'} onClick={oC2}>Confirmer</Button>,
    }

    return (
        <>
            {elements[page] || null}
        </>
    );
};

export default FooterButton;
